<template>
    <span class="hero-product-sparkle" :class="{'hero-product-sparkle--animate': animate}">
        <MaltImg class="hero-product-sparkle__img hero-product-sparkle__img--sm" src="/cms-front/sparkle-sm.png?vh=ca8631" alt="" width="18" />
        <MaltImg class="hero-product-sparkle__img hero-product-sparkle__img--md" src="/cms-front/sparkle-md.png?vh=54e8e4" alt="" width="30" />
        <MaltImg class="hero-product-sparkle__img hero-product-sparkle__img--lg" src="/cms-front/sparkle-lg.png?vh=921011" alt="" width="48" />
    </span>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';

    const {animate = false} = defineProps<{
        animate?: boolean;
    }>();
</script>

<style lang="scss">
    $ref-width: 70;

    .hero-product-sparkle {
        position: relative;
        display: inline-block;
        width: 70px;
        aspect-ratio: 1;

        &__img {
            position: absolute;
            transform: scale(0);
        }

        &__img--sm {
            width: calc(18 / $ref-width) * 100%;
            top: calc(52 / $ref-width) * 100%;
            left: calc(8 / $ref-width) * 100%;
        }

        &__img--md {
            width: calc(30 / $ref-width) * 100%;
            top: 0;
            left: calc(-4 / $ref-width) * 100%;
        }

        &__img--lg {
            width: calc(48 / $ref-width) * 100%;
            top: calc(18 / $ref-width) * 100%;
            left: calc(19 / $ref-width) * 100%;
        }

        &--animate &__img {
            transition: transform var(--ai-transition-duration) var(--ai-transition-timing-function);
            transform: scale(1);
        }

        &--animate &__img--sm {
            transition-delay: 0.2s;
        }

        &--animate &__img--lg {
            transition-delay: 0.6s;
        }
    }
</style>
